module.exports = __webpack_public_path__ + "img/3.39acd685.jpg";